import { useCallback, useState } from "react";

import PageShell from "../../components/shared/page-shell/page-shell.tsx";
import { ExtensionReportFilters } from "../../components/features/extension-report/components/extension-report-filters.tsx";
import { ExtensionReportTable } from "../../components/features/extension-report/components/extension-report-table.tsx";
import { useExtensionReport } from "../../components/features/extension-report/hooks/use-extension-report.ts";
import { useExtensionReportExport } from "../../components/features/extension-report/hooks/use-extension-report-export.ts";
import type { ExtensionReportFilters as Filters } from "../../components/features/extension-report/types.ts";

import styles from "./extension-report.module.css";

const INITIAL_FILTERS: Filters = {
  employeeId: null,
  fromDate: null,
  toDate: null,
  status: "",
};

export default function ExtensionReportPage() {
  const [filters, setFilters] = useState<Filters>(INITIAL_FILTERS);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const { data, totalElements, loading } = useExtensionReport(filters, page, pageSize);
  const { exportReport, exporting } = useExtensionReportExport();

  const handleApply = useCallback((next: Filters) => {
    setFilters(next);
    setPage(1);
  }, []);

  const handleReset = useCallback(() => {
    setFilters(INITIAL_FILTERS);
    setPage(1);
  }, []);

  return (
    <PageShell className={styles.page}>
      <ExtensionReportFilters
        value={filters}
        onApply={handleApply}
        onReset={handleReset}
        onExport={exportReport}
        loading={loading}
        exporting={exporting}
      />
      <ExtensionReportTable
        data={data}
        filters={filters}
        loading={loading}
        page={page}
        pageSize={pageSize}
        totalItems={totalElements}
        onPageChange={setPage}
        onPageSizeChange={(size) => {
          setPageSize(size);
          setPage(1);
        }}
      />
    </PageShell>
  );
}
